import ApplicationController from '../application_controller';

export default class RevealController extends ApplicationController {
  static targets = ["content", "secondaryContent", "secondaryContentParent", "openTrigger", "trigger"];
  static classes = ["hidden"];

  connect() {
    this.class = this.hasHiddenClass ? this.hiddenClass : "hidden"
  }

  toggle() {
    this.contentTargets.forEach(content => {
      content.classList.toggle(this.class)
    })
    this.syncTriggerAria();
  }

  show() {
    this.contentTargets.forEach(content => {
      content.classList.remove(this.class)
    })
    this.syncTriggerAria();
  }

  hide() {
    this.contentTargets.forEach(content => {
      content.classList.add(this.class)
    })
    this.syncTriggerAria();
  }

  hideTrigger() {
    this.openTriggerTarget.classList.add(this.class);
  }

  syncTriggerAria() {
    if (!this.hasContentTarget || !this.hasTriggerTarget) return;
    const expanded = this.contentTarget.classList.contains(this.class);
    this.triggerTargets.forEach((trigger) => trigger.setAttribute('aria-expanded', expanded));
  }
}
